export default __webpack_public_path__ + "static/media/LD1.300f7faa.png";